<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import { getUrlQuery, entranceJump, deepClone } from "./utils/fristJump";
import { mapMutations } from "vuex";
export default {
  name: "App",
  data() {
    return {
      oldid: "",
      timer: 0,
      isIframe:null
    };
  },
  provide () {
    return {
      app: this
    }
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      let oldstore = JSON.parse(sessionStorage.getItem("store"));
      oldstore.im.selectfriend = {
        wechatContactinfo: {
                friendid: '',
                wechatid: ''
            }, //当前聊天好友信息
        wechatMessage: {
          lastmsgid: 0,
          data: []
        } //当前好友聊天记录信息
      };
      oldstore.im.activeTeam= {
            type:0,
            activeindex:0,
            id: ''
        },
      oldstore.im.chatdata = {
        records: [],
        total: 0
      };
      this.oldid = oldstore.im.userMsg.user ? oldstore.im.userMsg.user.id : "";
      this.$store.replaceState(Object.assign({}, this.$store.state, oldstore));
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  methods: {
    ...mapMutations("im", ["USERINFO", "RESETVUEX"]),
    athentication() {
	  const href = window.location.href
      // const href = "http://im.dev.yunduocrm.cn/#/?router=im/setting/wechat_account_manage&hideheader=true&token=eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI5OSIsImlhdCI6MTYwMzk1MjQyMCwiaXNzIjoiY3JtLWluc2lkZSIsImF1ZCI6Inl1bmR1b19pbSIsImV4cCI6MTYwMzk2NjgyMH0.1c0BNlOQuocoQncxhR9L-uQRqRGSAjXgXmv_vU194Xc&busType=INNER_CRM"
      // const href = "http://im.dev.yunduocrm.cn/#/?router=im%2Fsetting%2Fwechat_account_manage&token=06de25695db2489baf5631990f17c28e&busType=UCT";
    this.isIframe = href.includes('ish3iframe')
    
      let redirectUrl = encodeURIComponent(decodeURIComponent(href));
      if (redirectUrl.includes("token") && redirectUrl.includes("busType")) {
        const initToken = getUrlQuery("token", href);
        const busType = getUrlQuery("busType", href);
        window.localStorage.setItem("initToken", initToken);
        window.localStorage.setItem("initBusType", busType);
      }
      window.sessionStorage.removeItem("IFRAME_LOAD");
      if (redirectUrl.includes("IFRAME_LOAD")) {
        const IFRAME_LOAD = getUrlQuery("IFRAME_LOAD", href);
        window.sessionStorage.setItem("IFRAME_LOAD", IFRAME_LOAD);
        let arr = redirectUrl.split('&')
        arr = arr.filter(v=>!v.includes('authToken'))
        redirectUrl = arr.join('&')
      }
      let initBusType = window.localStorage.getItem("initBusType"),
        initToken = window.localStorage.getItem("initToken");
      let redirectUrlCopy=decodeURIComponent(redirectUrl).replace('authToken=','delete001=')
      redirectUrlCopy=encodeURIComponent(decodeURIComponent(redirectUrlCopy).replace('token=','delete002='))
      if (href.includes("token") && href.includes("busType")) {
        console.log(`/auth/permission?busType=${initBusType}&token=${initToken}&redirectUrl=${redirectUrlCopy}`)
        this.$post(
          `/auth/permission?busType=${initBusType}&token=${initToken}&redirectUrl=${redirectUrlCopy}`
        ).then(res => {
          if (res.data.code === 200) {
            let { jwtToken, user, authPrivileges } = res.data.data;
            let userInfo = deepClone(res.data.data);
            let domainConfig = Object.keys(userInfo.domainConfig);
            if (href.startsWith("https://")) {
              domainConfig.forEach(key => {
                if(userInfo.domainConfig[key]){
                  userInfo.domainConfig[key] = userInfo.domainConfig[key].replace(
                    "http://",
                    "https://"
                  );
                  userInfo.domainConfig[key] = userInfo.domainConfig[key].replace(
                    "ws://",
                    "wss://"
                  );
                }

              });
            }
            let newuserdata = JSON.stringify(user);
            window.localStorage.setItem("token", jwtToken);
            window.localStorage.setItem("user", newuserdata);
            window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
            window.localStorage.setItem(
              "authPrivileges",
              JSON.stringify(authPrivileges)
            );
            this.USERINFO(userInfo);
            this.RESETVUEX();
            console.log(entranceJump(href), '00');
            this.$router.push(entranceJump(href));
            this.initSocket(authPrivileges);
          } else {
            window.location.href = res.data.data.redirectUrl;
          }
        });
      } else{
          let authPrivileges = localStorage.getItem('authPrivileges')
          if(authPrivileges){
              authPrivileges = JSON.parse(authPrivileges)
              this.initSocket(authPrivileges);
          }
      }
    },
    initSocket(authPrivileges) {
    //初始化websokecthttp://api.dev.yunduocrm.cn:12099/
      if (authPrivileges) {
        sessionStorage.setItem("wx_im", "");
        for (let i = 0; i < authPrivileges.length; i++) {
          if (authPrivileges[i].bt == "IM") {
            //查看是否有聊天权限
            const arr = authPrivileges[i].list.filter(v => { return v.pc == 'wx_im_chat_list_page' })
            let imdata = [];
            if (arr && arr.length > 0) {
              imdata = arr[0].list;
            }else{
              imdata = authPrivileges[i].list
            }

            const url = window.location.href;
            if (
              url.indexOf("talkskill") == -1 &&
              url.indexOf("chat_dailog") == -1 &&
              url.indexOf("wechatIframe") == -1 &&
              url.indexOf("crmsearchchat") == -1
            ) {
              this.socketApi.initWebSocket();
            }
            for (let j = 0; j < imdata.length; j++) {
              if (imdata[j].pc == "wx_im_chat") {
                sessionStorage.setItem("wx_im", "wx_im_chat");
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.athentication();
    // console.log('55555')
  },
  //销毁前清除定时器
  beforeDestroy() {
    // localStorage.clear();
    // clearInterval(this.timer)
  }
};
</script>

<style lang="less">
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
  // -moz-user-select: none;
  // -khtml-user-select: none;
  // user-select: none;
  padding-right: 0 !important;
}

a {
  display: inline-block;
}

button {
  border: 0;
  background-color: transparent;
  outline: none;
}

//全局弹窗
#app .el-dialog {
  border-radius: 8px;
}

#app .el-dialog__header {
  border-radius: 8px 8px 0px 0px;
  padding: 22px 20px 22px 30px;
  height: 18px;
  color: #2a2a2a;
}

#app .el-dialog__body {
  padding: 0px 20px 0px 20px;
  color: #707478;
  min-height: 84px;
}

#app .el-dialog__footer {
  padding: 20px 20px 30px 30px;

  .el-button {
    //按钮尺寸
    width: 60px;
    height: 32px;
    border-radius: 2px;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
    padding: 0 0;
    font-weight: 400;
  }
}

//全局列表
.el-pagination {
  font-weight: 300;
}

.el-dialog__wrapper {
  overflow: hidden;
}

.tabel-hand {
  background: #f5f6f8 !important;
  color: #4c4c4c !important;
  font-weight: 400 !important;
}

.el-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  border-radius: 5px;
}

.text-btn:after {
  margin-left: 6px;
  margin-right: 6px;
  content: "|";
  color: #dadee0;
}

//文字链接默认颜色
.el-button--text {
  color: #0099ff;
}

.el-button--text:hover {
  color: #33adff !important;
}

//按钮颜色
.el-button el-button--default {
  color: #93999f;
}

#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2a2a2a;
}

#app input {
  font-size: 14px;
  text-indent: 8px;

  &::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #999;
    font-size: 14px;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #999;
    font-size: 14px;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #999;
    font-size: 14px;
  }
}

.flex {
  display: flex;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue